import {httpClient} from './';

export const _uploadMainClient = moduelForm => {
  return httpClient
    .post(`module_manage/appasar/upload`, { ...moduelForm })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getAllMachineList = () => {
  return httpClient.get(`module_manage/machine/list`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _publishClientApp = (
  canteen_machine_list,
  is_all_canteen,
  app_version_uuid
) => {
  return httpClient
    .post(`module_manage/appasar/publish`, {
      canteen_machine_list,
      is_all_canteen,
      app_version_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _changeCustomModule = (machine_uuid, module_type) => {
  return httpClient
    .post(`module_manage/custom_module/change`, {
      machine_uuid,
      module_type
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getCustomMachine = () => {
  return httpClient.get(`module_manage/custom_module/list`).then(res => {
    console.log(res);
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getClientAppList = () => {
  return httpClient.get(`/module_manage/appasar/list`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _uploadApiZip = modulForm => {
  console.log(modulForm);
  return httpClient.post(`module_manage/api/upload`, modulForm).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _getApimoduleList = () => {
  return httpClient.get(`module_manage/api/list`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _publishApiModule = (
  canteen_machine_list,
  is_all_canteen,
  app_version_uuid
) => {
  return httpClient
    .post(`module_manage/api/publish`, {
      canteen_machine_list,
      is_all_canteen,
      api_version_uuid: app_version_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getRegionModelList = () => {
  return httpClient.get(`module_manage/detection_model/list`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _publishRegionModel = (
  canteen_machine_list,
  is_all_canteen,
  app_version_uuid
) => {
  return httpClient
    .post(`module_manage/detection_model/publish`, {
      canteen_machine_list,
      is_all_canteen,
      model_uuid: app_version_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getFoodModelList = () => {
  return httpClient
    .post(`module_manage/food_recognition_model/list`)
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};

export const _publishFoodModel = (
  canteen_machine_list,
  is_all_canteen,
  app_version_uuid
) => {
  return httpClient
    .post(`module_manage/food_recognition_model/publish`, {
      canteen_machine_list,
      is_all_canteen,
      model_uuid: app_version_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _pullFoodModel = () => {
  return httpClient
    .get(`module_manage/food_recognition_model/list/update`)
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getDishModelList = () => {
  return httpClient
    .get(`module_manage/dish_recognition_model/list`)
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _publishDishModel = ({
  canteen_id,
  machine_uuid_list,
  model_uuid
}) => {
  return httpClient
    .post(`module_manage/dish_recognition_model/publish`, {
      canteen_id,
      machine_uuid_list,
      model_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getCurretnVersion = machine_uuid => {
  console.log(machine_uuid);
  return httpClient
    .post(`module_manage/current_version/list`, {
      machine_uuid
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _getCurrentVersionList = () => {
  return httpClient
    .post(`module_manage/current_version/batch_list`, { is_all_machine: "1" })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _queryModulePublishMachine = (module_uuid, module_type) => {
  return httpClient
    .post(`module_manage/module_publish/query`, { module_uuid, module_type })
    .then(res => {
      return Promise.resolve(res);
    });
};
